import PersonList from "./components/List"
import PersonForm from "./components/Form"
import PersonView from "./components/View"

let module = "persons"

export default [
  { path: "persons", component: PersonList, meta: { module: module, permissions: ["person-access"] } },
  { path: "persons/create", component: PersonForm, props: true, meta: { module: module, permissions: ["person-create"] } },
  { path: "persons/edit/:id", component: PersonForm, props: true, meta: { module: module, permissions: ["person-edit"] } },
  { path: "persons/view/:id", component: PersonView, props: true, meta: { module: module, permissions: ["person-access"] } }
]
